/**
 * Apply rubric settings to a settings object
 * @param {Object} rubric - Rubric data from API
 * @param {Function} applyFn - Function to apply each setting (key, value) => void
 * @param {Object} data - Data containing categories, intensities arrays
 */
export function applyRubricSettings(rubric, applyFn, data) {
  if (!rubric || !applyFn) return;

  if (rubric.gradeLevel) {
    applyFn("selectedGradeLevel", rubric.gradeLevel);
  }

  if (rubric.category && data?.categories) {
    const categoryIdx = data.categories.findIndex(
      (cat) => cat.value === rubric.category || cat.label === rubric.category
    );
    if (categoryIdx !== -1) {
      applyFn("selectedCategoryIdx", categoryIdx);
    }
  }

  if (rubric.intensity && data?.intensities) {
    const intensityIdx = data.intensities.findIndex(
      (int) => int.value === rubric.intensity || int.label === rubric.intensity
    );
    if (intensityIdx !== -1) {
      applyFn("selectedIntensityIdx", intensityIdx);
    }
  }

  const languageId =
    rubric.languageId || rubric.LanguageId || rubric.language?.id;
  if (languageId) {
    applyFn("selectedLanguageId", languageId);
  }
}
